export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <span>© {year} Easy Fitness. All rights reserved.</span>
    </footer>
  );
}
